import React from "react"

const ProjectCard = ({ project, openProject }) => {
	const handleButtonClick = () => {
		openProject(project.id)
	}

	return (
		<div className="col col-12 col-ms-12 col-md-6 col-lg-3">
			<div className="projectCard">
				<img src={project.images[0]} alt={project.name} />
				<div className="projectDetail">
					<p>{project.name}</p>
					<button onClick={handleButtonClick}>Read More</button>
				</div>
			</div>
		</div>
	)
}

export default ProjectCard
